<template>
  <div id="berandaguru">
        <h1 class="title is-4" >Data Guru</h1>
        
        <div id="navbar" class="mw-980">
            <b-navbar class="has-background-white-ter">
              <!-- <template slot="brand">
              </template> -->
              <template slot="start">
                 <b-button  class="is-success" 
                  tag="router-link"
                  to="/biro/datakehadiran"
                  @click="tambahData()"
                 rounded icon-left="account-plus"
                 >Tambah Daftar Pelatihan</b-button>
                 <!-- <b-button
                    label="Tambah Daftar Pelatihan"
                    class="button is-primary"
                    rounded icon-left="account-plus"
                    @click="isComponentModalActive = true" />

                <b-modal
                    v-model="isComponentModalActive"
                    has-modal-card
                    full-screen
                    :can-cancel="false">
                    <template #default="props">
                        <modal-form
                        :email="formProps.email"
                        :password="formProps.password">
                        </modal-form>
                    </template>
                </b-modal> -->
              </template>
              <template slot="end">
                <b-field position="is-centered">
                  <b-input placeholder="Cari Nama Guru" type="search" v-model="search"
                  icon="magnify">
                  </b-input>
              </b-field>
              </template>
            </b-navbar>
        </div>
     
        <div id="content" class="mw-980 box">
          <div >
             <section>
              <b-table
                  :data="filteredList"
                  bordered
                  striped
                  narrowed
                  hoverable
                  :loading="isLoading"
                  :mobile-cards="true"
                  ref="table"
                  paginated
                  :per-page="perPage"
                  aria-next-label="Next page"
                  aria-previous-label="Previous page"
                  aria-page-label="Page"
                  aria-current-label="Current page">

                  <b-table-column 
                  field="index" label="No" width="40" numeric v-slot="props">
                      {{ props.row.index }}
                  </b-table-column>
                  <b-table-column field="id_guru" label="ID Guru" :visible="false" sortable v-slot="props">
                       {{ props.row.id_guru}}
                  </b-table-column>
                  <b-table-column field="nama_guru" label="Nama Guru" sortable v-slot="props">
                       {{ props.row.nama_guru}}
                  </b-table-column>

                   <template slot="bottom-left">
                     <div class="columns">
                      <div class="column">
                        <b-field horizontal label="Row">
                          <b-select v-model="perPage">
                          <option value="10">10 Per Page</option>
                          <option value="30">30 Per Page</option>
                          <option value="50">50 Per Page</option>
                          </b-select>
                        </b-field>
                      </div>
                     </div>
                  </template>

                   <b-table-column label="Kehadiran" v-slot="props">
                    <b-field>
                        <b-select placeholder="Select" expanded>
                            <option value="hadir">Hadir</option>
                            <option value="not">Tidak Hadir</option>
                        </b-select>
                    </b-field>
                  </b-table-column>

                  <template slot="empty">
                    <section class="section">
                      <div class=" content has-text-grey has-text-centered">
                        <p>{{ tableMessage}}</p>
                      </div>
                    </section>
                  </template> 
              </b-table>
            </section>
          </div>
        </div>
      </div>
</template>

<script>
var $ = require('jquery')
// const ModalForm = {
//     props: ['email','password'],
//     template: `
//     <div class="modal-card">
//         <div class="mw-420">
//             <header class="modal-card-head">
//                 <p class="modal-card-title">Tambah Data Pelatihan</p>
//             </header>
//             <section class="modal-card-body">
//                 <b-field label="Nama Pelatihan">
//                     <b-input
//                         type="email"
//                         :value="email"
//                         placeholder="Nama Pelatihan"
//                         required>
//                     </b-input>
//                 </b-field>

//                 <b-field label="Password">
//                     <b-input
//                         type="password"
//                         :value="password"
//                         password-reveal
//                         placeholder="Your password"
//                         required>
//                     </b-input>
//                 </b-field>

//                 <div id="content" class="mw-980 box">
//                     <div >
//                         <section>
//                         <b-table
//                             :data="filteredList"
//                             bordered
//                             striped
//                             narrowed
//                             hoverable
//                             :loading="isLoading"
//                             :mobile-cards="true"
//                             ref="table"
//                             paginated
//                             :per-page="perPage"
//                             aria-next-label="Next page"
//                             aria-previous-label="Previous page"
//                             aria-page-label="Page"
//                             aria-current-label="Current page">

//                             <b-table-column 
//                             field="index" label="No" width="40" numeric v-slot="props">
//                                 {{ props.row.index }}
//                             </b-table-column>
//                             <b-table-column field="id_guru" label="ID Guru" :visible="false" sortable v-slot="props">
//                                 {{ props.row.id_guru}}
//                             </b-table-column>
//                             <b-table-column field="nama_guru" label="Nama Guru" sortable v-slot="props">
//                                 {{ props.row.nama_guru}}
//                             </b-table-column>

//                             <template slot="bottom-left">
//                                 <div class="columns">
//                                 <div class="column">
//                                     <b-field horizontal label="Row">
//                                     <b-select v-model="perPage">
//                                     <option value="10">10 Per Page</option>
//                                     <option value="30">30 Per Page</option>
//                                     <option value="50">50 Per Page</option>
//                                     </b-select>
//                                     </b-field>
//                                 </div>
//                                 </div>
//                             </template>

//                             <b-table-column label="Kehadiran" v-slot="props">
//                                 <b-field>
//                                     <b-select placeholder="Select" expanded>
//                                         <option value="hadir">Hadir</option>
//                                         <option value="not">Tidak Hadir</option>
//                                     </b-select>
//                                 </b-field>
//                             </b-table-column>

//                             <template slot="empty">
//                                 <section class="section">
//                                 <div class=" content has-text-grey has-text-centered">
//                                     <p>{{ tableMessage}}</p>
//                                 </div>
//                                 </section>
//                             </template> 
//                         </b-table>
//                         </section>
//                     </div>
//                 </div>
//             </section>
//             <footer class="modal-card-foot">
//                 <b-button
//                     label="Close"
//                     @click="$parent.close()" />
//                 <b-button
//                     label="Login"
//                     type="is-primary" />
//             </footer>
//         </div>
//     </div>
//     `,
//     methods:{
//     //   netralizeEmail(){
//     //     this.$emit("netralizeEmail")
//     //   },
//     //   netralizePassword(){
//     //     this.$emit("netralizePassword")
//     //   },
//     //   reset(){
//     //     this.email.type='',
//     //     this.email.message='',
//     //     this.email.value ='',
//     //     this.password.value ='',
//     //     this.password.message='',
//     //     this.password.type=''
//     //   }
//     }
//   }
export default {
    components: {
        // ModalForm
    },
    data() {
        return {
            defaultOpenedDetails: [1],
            showDetailIcon: true,
            isComponentModalActive: false,
            file:null,
            gurus:[],
            perPage:'10',
            guru:{
                nuptk : '',
                nama_guru:'',
                // jenis_kelamin: '',
                // tgl_lahir:'',
                // no_handphone:'',
                // email:'',
                // mata_pelajaran:'',
                // jenis_guru:'',
                // nama_sekolah:'',
                // nama_regu:''
            },
            detailId:'',
            //tableLoadingIcon:'sync',
            tableMessage:'Loading...',
            detailOpened:[],
            isLoading:true,
            snackbarMessage:'',
            search:'',
            // id_biro:'',
            activeUser:Object,
            activeBiro:Object,
            config: {},
            formProps: {
                email: { value: '', type: '', message: '' },
                password: { value: '', type: '', message: '' },
            },
        }
   },
   computed: {
     filteredList() {
        return this.gurus.filter(guru => {
            return guru.nama_guru.toLowerCase().includes(this.search.toLowerCase())
            // guru.email.toLowerCase().includes(this.search.toLowerCase())
        })
      },
  
    },
  methods: {
    getDataByBiro()
    {
      this.isLoading=true
      var uri = this.$apiUrl + 'guru/biro/' + this.detailId
      this.gurus = []

      this.$http.get(uri, this.config).then(response =>
      {
        this.gurus = response.data.value
        console.log(this.gurus)
        for(var i=0; i<this.gurus.length; i++)
        {
          this.gurus[i].index = i+1
          // if(this.gurus[i].tgl_lahir === null){
          //   this.gurus[i].tgl_lahir = '-'
          // }
        }
        this.tableMessage ='Tidak ada data yang sesuai'
        this.isLoading=false
      })
      .catch(error =>{
        this.errors = console.error
        this.tableMessage='Tidak ada Data'
        this.isLoading = false
      })
    },
    deleteData(deleteID)
    {
      var uri = this.$apiUrl + 'guru/delete/' + deleteID

      this.$http.post(uri, null, this.config).then(response=>
      {
        this.getDataByBiro();
        this.snackbarMessage = response
        this.snackbar('Data Berhasil dihapus','is-success')
      })
      .catch(error=>
      {
        this.errors = error
       // this.snackbarMessage = "Silahkan coba hapus lagi"
        this.snackbar(this.snackbarMessage,'is-danger')
        this.snackbar("Silahkan coba lagi",'is-danger')
      })
    },
    cetakSertifikat(id_guru)
    {
      this.isLoading = true
      var urlCetak = this.$apiUrl + 'cetakGuru/' + this.detailId + '/' + id_guru
      // window.open(urlCetak)
      this.$http.get(urlCetak, {
        headers: {
          'Authorization': 'Bearer ' + this.$session.get('token'),
          'Content-Type': 'application/json',
          'Accept': 'application/pdf'
        }
      }).then(response => {
        let link = document.createElement('a')
        link.href = response.data.value
        link.download = response.data.file_name
        link.click()
        this.isLoading = false
      })
      .catch(error =>{
        console.log(error)
        this.snackbar(error.response.data.Message, 'is-danger')
        this.isLoading = false
      })
    },
    snackbar(message,type)
    {
        this.$buefy.toast.open({
          duration:5000, //5 detik
          message:message,
          type:type,
          position:'is-top',
          actionText:'OK',
          queue:false,
      })
    },
    confirmDelete(deleteID)
    {
       this.$buefy.dialog.confirm({
        title:'Hapus Guru',
        message:'Apa anda yakin ingin menghapus ?',
        confirmText:'Hapus',
        cancelText:'Batal',
        type:'is-danger',
        hasIcon:true,
        onConfirm:() =>this.deleteData(deleteID)
      })
    }
  },
  mounted()
  {
    //this.getData();
    if(this.$session.exists()){
      this.activeUser = this.$session.get('user')
      this.config = {
        headers: {
          'Authorization': 'Bearer ' + this.$session.get('token')
        }
      }
    }
     this.activeBiro = this.$session.get('biro')
        if(this.activeBiro)
        {
          this.detailId = this.activeBiro.id_biro
          this.getDataByBiro()
        }
  }

}
</script>

<style scoped>
.mw-980 {
  max-width: 980px;
  width: 100%;
  margin-left: auto;
  margin-right: auto;
}
.mw-420 {
  max-width: 420px;
  width: 100%;
  justify-content: center;
  margin-left: auto;
  margin-right: auto;
}

</style>

